import React, { useState } from 'react';
import { KeenIcon } from '@/components';
import { ManageDomainAgent } from './ManageDomainAgent';

const DomainAgent = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="space-y-4">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`w-full flex items-center justify-between py-2 px-4 border border-black border-opacity-50 
          ${isOpen ? 'bg-gray-300' : 'bg-white'} rounded-md hover:bg-gray-200 transition-colors`}
      >
        <h3 className="text-base font-bold"><KeenIcon icon="icon" className="mr-2"/>Domain Agent</h3>
        <span className="text-gray-500">
          {isOpen ? <KeenIcon icon="down" /> : <KeenIcon icon="right" />}
        </span>
      </button>
      
      {isOpen && (
        <div className="space-y-2 p-4 border rounded-lg">
          <div className="py-3 rounded-lg">
            <ManageDomainAgent/>
          </div>
        </div>
      )}
    </div>
  );
};

export { DomainAgent };
